import { openCloseToast } from "../Global/actions";
import apiMessages from "../../helpers/apiMessages";

export const showMessageApi = (textStatusOK, response, result) => async (dispatch) => {
  switch (response.status) {
    case 200: case 201:
      if (textStatusOK) { dispatch(showToastSuccess(textStatusOK)); }
      break;
    case 204:
        if (textStatusOK) { dispatch(showToastError(textStatusOK)); } else { dispatch(showToastError()); }
        break;
    case 400:
      if (result && result.Message) { dispatch(showToastError(result.Message)); } else { dispatch(showToastError()); }
      break;
    case 409:
        if (result && result.Message) { dispatch(showToastWarning(result.Message)); } else { dispatch(showToastWarning()); }
        break;
    case 500:
      if (result && result.Id) {
        const text = `${apiMessages.errorDefault} Código de error: ${result.Id}.`;
        dispatch(showToastError(text));
      } else { dispatch(showToastError()); }
      break;
    default:
      dispatch(showToastError());
      break;
  }
};
export const menuNavigation = ({ hoverIndex, activeIndex, isHovering }) => ({
  type: "MENU_NAVIGATION",
  hoverIndex,
  activeIndex,
  isHovering,
});

export const openCloseModalGallery = (isOpen, gallery, title) => ({
  type: "OPEN_CLOSE_MODAL_GALLERY",
  isOpen,
  gallery,
  title,
});

export const showToastError = (text = apiMessages.errorDefault) => async (dispatch) => {
  dispatch(openCloseToast({
    isToastOpen: true,
    msgToast: text,
    typeStyle: "error",
    displayTime: 5000
  }));
};

export const showToastWarning = (text = apiMessages.errorDefault) => async (dispatch) => {
  dispatch(openCloseToast({
    isToastOpen: true,
    msgToast: text,
    typeStyle: "warning",
    displayTime: 5000
  }));
};

export const showToastSuccess = (text = apiMessages.succesDefault) => async (dispatch) => {
  dispatch(openCloseToast({
    isToastOpen: true,
    msgToast: text,
    typeStyle: "success",
    displayTime: 5000
  }));
};

